import { createFileRoute } from "@tanstack/react-router";
import { EmployeeForm } from "@/components/employees/employee-form";

export const Route = createFileRoute("/_workspace/employees/new")({
  component: NewEmployeePage,
});

function NewEmployeePage() {
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl">
        <EmployeeForm employee={null} />
      </div>
    </main>
  );
}
